import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import storageService from '../../services/storage.service';

const useManageStorage = () => {
  const queryClient = useQueryClient();

  // Hydrate from indexedDB

  const readFromStorage = useCallback(async () => {
    const storageData = await storageService.getItem<any>('queries');

    if (storageData !== null) {
      const queriesWithData = storageData;

      for (const queryKey in queriesWithData) {
        const data = queriesWithData[queryKey];
        queryClient.setQueryData([queryKey], data);
      }
    }
  }, [queryClient]);

  const writeToStorage = useCallback(
    async (queryKey: string, data: any) => {
      let storageData = await storageService.getItem<any>('queries');

      storageData = {
        ...(storageData ?? {}),
        [queryKey]: data,
      };
      await storageService.setItem('queries', storageData);
      await readFromStorage();
    },
    [readFromStorage],
  );

  const deleteFromStorage = useCallback(
    async (keys: string[]) => {
      const storageData = await storageService.getItem<any>('queries');
      if (!storageData) return;
      const storageKeys = Object.keys(storageData);

      if (storageData !== null && keys) {
        const filteredStorage = storageKeys
          .filter((key) => !keys.includes(key))
          .reduce((obj: any, key) => {
            obj[key] = storageData[key];
            return obj;
          }, {});

        await storageService.removeItem('queries');
        await storageService.setItem('queries', { ...filteredStorage });

        for (const query of storageKeys) {
          queryClient.removeQueries({ queryKey: [query] });
        }
      }
    },
    [queryClient],
  );

  return { writeToStorage, readFromStorage, deleteFromStorage };
};

export default useManageStorage;
